import { html, Component, createRef } from "../lib/index.js";

const paletteIcon = html`
	<svg width="1em" height="1em" viewBox="0 0 24 24"
		fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12 3C7 3 3 7 3 12C3 16.5 6.5 20 11 21C11.5 21.1 12 20.7 12 20.2C12 19.9 11.9 19.7 11.6 19.5C11.2 19.2 11 18.8 11 18.3C11 17.6 11.6 17 12.3 17H14.5C18.1 17 21 14.1 21 10.5C21 6.4 17 3 12 3Z"
			stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
		<circle cx="7.5" cy="11.5" r="1.2" fill="currentColor"/>
		<circle cx="9.5" cy="7.5" r="1.2" fill="currentColor"/>
		<circle cx="14.5" cy="7.5" r="1.2" fill="currentColor"/>
		<circle cx="16.5" cy="11.5" r="1.2" fill="currentColor"/>
	</svg>
`;

const THEMES = [
	{ value: "auto", label: "Auto" },
	{ value: "light", label: "Light" },
	{ value: "dark", label: "Dark" },
	{ value: "discord", label: "Discord-ish" },
];

// A theme picker that works before logging in, unlike the full Settings
// dialog which is only reachable once connected.
//
// Deliberately not a plain <select>: its dropdown is an OS-rendered
// popup that our CSS (and even the color-scheme property, in at least
// some browsers) can't reliably theme, so it can show up as an
// unreadable plain white box under a dark theme. <details>/<summary>'s
// disclosed content is regular DOM we fully control instead.
export default class ThemeSwitcher extends Component {
	details = createRef();

	constructor(props) {
		super(props);
		this.handleDocumentClick = this.handleDocumentClick.bind(this);
	}

	componentDidMount() {
		document.addEventListener("click", this.handleDocumentClick);
	}

	componentWillUnmount() {
		document.removeEventListener("click", this.handleDocumentClick);
	}

	handleDocumentClick(event) {
		let el = this.details.current;
		if (el && el.open && !el.contains(event.target)) {
			el.open = false;
		}
	}

	handleSelect(value) {
		this.props.onChange(value);
		if (this.details.current) {
			this.details.current.open = false;
		}
	}

	render() {
		let current = THEMES.find((t) => t.value === this.props.theme) || THEMES[0];
		let items = THEMES.map((t) => html`
			<li>
				<button
					type="button"
					class=${t.value === this.props.theme ? "selected" : ""}
					onClick=${() => this.handleSelect(t.value)}
				>${t.label}</button>
			</li>
		`);
		return html`
			<details id="theme-switcher" ref=${this.details}>
				<summary title="Theme">${paletteIcon} ${current.label}</summary>
				<ul>${items}</ul>
			</details>
		`;
	}
}
